import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import UserMenu from '../entities/userMenu'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';
import MenuDropDown from '../entities/menuDropDown'

interface UserMenuState extends ListState<UserMenu> {
    editUserMenu: UserMenu;
    menuDropDownList: any;
}
class UserMenuModule extends ListModule<UserMenuState, any, UserMenu>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<UserMenu>(),
        loading: false,
        editUserMenu: new UserMenu(),
        menuDropDownList: new Array<MenuDropDown>()
    }
    actions = {
        async getAll(context: ActionContext<UserMenuState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/NavigationMenu/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<UserMenu>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<UserMenuState, any>, payload: any) {
            await Ajax.post('/api/services/app/NavigationMenu/Create', payload.data);
        },
        async update(context: ActionContext<UserMenuState, any>, payload: any) {
            await Ajax.put('/api/services/app/NavigationMenu/Update', payload.data);
        },
        async delete(context: ActionContext<UserMenuState, any>, payload: any) {
            await Ajax.delete('/api/services/app/NavigationMenu/Delete?Id=' + payload.data.id);
        },

        async get(context: ActionContext<UserMenuState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/NavigationMenu/Get?Id=' + payload.id);
            return reponse.data.result as UserMenu;
        },
        async recover(context: ActionContext<UserMenuState, any>, payload: any) {
            await Ajax.post('/api/services/app/NavigationMenu/Recover', payload.data);
        },
        async loadMenuTree(context: ActionContext<UserMenuState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/NavigationMenu/GetMenuDropDownList', { params: payload.data });
            context.state.menuDropDownList = reponse.data.result as Array<MenuDropDown>;
        }
    };
    mutations = {
        setCurrentPage(state: UserMenuState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: UserMenuState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: UserMenuState, userMenu: UserMenu) {
            state.editUserMenu = userMenu;
        }
    }
}
const userMenuModule = new UserMenuModule();
export default userMenuModule;